import React from 'react'
import { Modal, Button, Row, Col } from 'react-bootstrap'
import { Box } from 'reactjs-admin-lte'
import { tableHelper } from 'utils/helpers'
import ReactPaginate from 'react-paginate'
import FontAwesome from 'react-fontawesome'
import MessageStore from 'stores/MessageStore'
import MessageSendModal from './MessageSendModal'
import Lightbox from 'react-images-extended';
import IframeModal from 'component/element/IframeModal'
import ConfirmPopup from 'component/element/ConfirmPopup';
import PDF from '../../asset/img/pdf-512.png';
import './MessagePopup.css'
import withSizes from 'react-sizes'
import ReportMobileTable from '../report/ReportMobileTable'
import PurchaseOrderDocModal from '../po/PurchaseOrderDocModal';

class MessagePopup extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      pageCount: 1,
      activePage: 1,
      loading: false,
      showConfirmDel:false,      
      messages: [],
      sendMsg:{},
      sendMsgIndex:-1,
      sendMode:'',
      unread_count:0,
      images:[],currentImage:0,lightboxIsOpen:false,
    }
  }

  componentWillReceiveProps(newProps){
    
    if(newProps.show && newProps.show!==this.props.show){
      this.loadMessage()
    }
  }

  reloadData(){
    this.loadMessage()
  }

  loadMessage() {
    this.setState({loading:true})
    MessageStore.loadAllMessage((result) => {
      let messages = result.data.map((item,index)=>{
        item.message = Object.assign({showMore:false},item.message)
        return item
      })
      
      if(this.props.onUpdateUnreadCount!==undefined){
        this.props.onUpdateUnreadCount(result.unread_count)
      }
      this.setState({loading:false,messages:messages,unread_count:result.unread_count})
    },()=>{
      this.setState({loading:false}) 
    })
  }

  onDeleteMsgClick(msgId, e) {
    this.setState({
      loading: true
    })
  }

  onReplyClick(index,msgId, e) {
    let {messages} = this.state
    this.setState({showSend:true,sendMsgIndex:index,sendMsg:messages[index],sendMode:'reply'})
  }

  

  onModalCloseClick() {
    this.onHide()
  }

  onWorkClick(workNo){
    if (process.env.NODE_ENV == "development") {
      alert('show_work_doc:'+workNo)
    }else{
      if(window.show_work_doc!==undefined)
        window.show_work_doc(workNo,'#tab_wd10')
    }
    this.props.onHide()
  }

  onPOClick(poNo){
    //PO Modal    
    this.refs.poDocModal.loadData(poNo)    
  }

  onReadMore(){

  }

  onReadStatusClick(index,msgId){
    let {messages,unread_count} = this.state
    MessageStore.updateReadMessage(msgId,(result) => {
      
      messages[index].read_flag = '1'
      unread_count = unread_count-1
      this.setState({loading:false,messages:messages,unread_count:unread_count})

      if(this.props.onMarkReadMessage!==undefined){
        this.props.onMarkReadMessage()
      }
    },()=>{

    })
  }

  onDeleteMsgClick(index,msgId){
    let {messages,unread_count} = this.state
    MessageStore.archiveMessage(msgId,(result) => {
      
      
      
      if(messages[index].read_flag==='0' && this.props.onMarkReadMessage!==undefined){
        unread_count = unread_count - 1
        this.props.onMarkReadMessage()
      }
      messages.splice(index, 1);
      this.setState({loading:false,messages:messages,unread_count:unread_count})
    },()=>{

    })
  }

  onMsgClick(index){
    let {messages} = this.state
    this.setState({showSend:true,sendMode:'read',sendMsg:messages[index]})
  }

  getEmptyMessage(){
    return {bf_message_id:'',sender_id:'',sender_name:'',recipient_id:'',message:{type:'text',text:''},origin_id:0,reply_list:[]}
  }

  onSendClick(){

    this.setState({showSend:true,sendMode:'send',sendMsg:this.getEmptyMessage()})
  }

  onArchiveAllReadMessage(){
    this.setState({loading:true})
    MessageStore.archiveAllReadMessage(()=>{
      this.setState({showConfirmDel:false})
      this.loadMessage()      
    },()=>{
      this.setState({loading:false,showConfirmDel:false})
    })
  }

  onShowAllText(index,msg,status) {
    let {messages} = this.state
    messages[index].message.showMore = status
    this.setState({messages:messages})
  }

  renderMessageText(index,message){
    let msg = (message.text===null||message.text===undefined?'':message.text)
    if (msg.length>80&&!message.showMore) {
      let _80 = msg.substr(0, 80)
      let msg_converted = _80.replace(/\n/g, "<br />")
      return([
        <span key={0} onClick={this.onMsgClick.bind(this,index)} dangerouslySetInnerHTML={{__html: msg_converted}}></span>,
        <span key={1} onClick={this.onShowAllText.bind(this,index,msg,true)} style={{color:'#46b8da',cursor:'pointer'}}>
          &nbsp;more...
        </span>
      ])
    } else if (msg.length>80&&message.showMore) {
      let msg_converted = msg.replace(/\n/g, "<br />")
      return([
        <span key={0} onClick={this.onMsgClick.bind(this,index)} dangerouslySetInnerHTML={{__html: msg_converted}}></span>,
        <span key={1} onClick={this.onShowAllText.bind(this,index,msg,false)} style={{color:'#46b8da',cursor:'pointer'}}>
          &nbsp;hide...
        </span>
      ])
    } else {
      let msg_converted = msg.replace(/\n/g, "<br />")
      return (
        <span onClick={this.onMsgClick.bind(this,index)} dangerouslySetInnerHTML={{__html: msg_converted}}></span>
      )
    }  
  }

  renderText(index,message,showWork=true){
    if(message.work_no!==undefined && showWork){
      return (<div>
         
        <Button bsSize={'sm'} bsStyle='success' onClick={this.onWorkClick.bind(this,message.work_no)}><FontAwesome name='reply' />{message.work_no}</Button>
        {' '}{this.renderMessageText(index,message)} 
      </div>)  
    }
    if(message.po_no!==undefined && showWork){
      return (<div>
         
        <Button bsSize={'sm'} bsStyle='warning' onClick={this.onPOClick.bind(this,message.po_no)}><FontAwesome name='reply' />PO {message.po_no}</Button>
        {' '}{this.renderMessageText(index,message)} 
      </div>)  
    }
    return this.renderMessageText(index,message)
  }

  renderReplyList(row,rindex){
    return row.reply_list.map((item,index)=>(
      <div key={index} className='reply-item'>        
        <FontAwesome name='angle-double-right'/>{item.message.type=='image'?this.renderImg(index,item):this.renderText(index,item.message,false)}
      </div>
    ))
  }

  onImgPreviewClick(item,index,e) {
    let {data,images} = this.state
    
    item.message.imageUrl.forEach(function(_item,_index) { 
      let type = _item.substring(_item.length-3)
      let imageUrl = ''
      let thumbUrl = ''
      if (type=='pdf') {
        imageUrl = PDF
        thumbUrl = PDF
      } else {
        imageUrl = _item
        thumbUrl = item.message.thumbUrl[index]
      }

      images.push({
        src: imageUrl,
        thumbnail: thumbUrl,
        srcset: [imageUrl],
        caption: ''
      })  
    })
    this.setState({currentImage:index,lightboxIsOpen:true,images:images})
  }

  onClickImage(e) {
    let {images} = this.state

    if (this.state.currentImage === 0) {
      this.onClickNext()
    } else if (this.state.currentImage === images.length-1) {
      this.onClickPrevious()
    }
  }

  onClickNext() {
    this.setState({currentImage:this.state.currentImage + 1})
  }

  onClickPrevious() {
    this.setState({currentImage:this.state.currentImage - 1})
  }

  onCloseLightbox(e) {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
      images:[]
    });
  }

  newTabPdfClick(url) {
    // if (process.env.NODE_ENV == "development") {
    //   url  = ''
    // } else{
    //   url = ''
    // }
    this.refs.iframe.loadUrl(url) 
  }

  renderImgZone(index,item) {
    if (item.message.thumbUrl.length===0||item.message.thumbUrl===undefined) {
      return(<li></li>)
    } else {
      return(
        item.message.thumbUrl.map((_item,_index)=> {
          let type = item.message.imageUrl[_index].substring(item.message.imageUrl[_index].length-3)
          let imageUrl = ''
          if (type=='pdf') {
            imageUrl = PDF
          } else {
            imageUrl = _item
          }

          let posName = parseInt(item.message.imageUrl[_index].indexOf('msg_'))+parseInt(10)
          let fileName = item.message.imageUrl[_index].substr(posName)
          return(
            <li key={_index} onClick={type=='pdf'?this.newTabPdfClick.bind(this,item.message.imageUrl[_index]):this.onImgPreviewClick.bind(this,item,_index)}>
              <div style={{position:'relative'}}>
                <div style={{borderRadius:'8px',backgroundImage:'url('+imageUrl+')',backgroundPosition:'50% 50%',backgroundRepeat:'no-repeat',height:'54px',width:'54px',backgroundSize:'cover'}}></div>
                {type=='pdf'?<small className='text-center ellipsis' style={{width:'54px'}}>{decodeURIComponent(fileName)}</small>:''}
              </div>  
            </li>
          )
        })
      )
    }
  }

  renderImg(index,item) {
    return(
      <center>
        <div className='box-slide-img-before-send' style={{width:'290px'}}>
          <ul className='slide-img-before-send'>
            {this.renderImgZone(index,item)}
          </ul> 
        </div>
      </center>
    )
  }

  onReplySent(itemMsg){
    let {sendMsgIndex,messages,unread_count} = this.state
    if(sendMsgIndex>=0 && sendMsgIndex<messages.length){
      if(messages[sendMsgIndex].reply_list===undefined)
        messages[sendMsgIndex].reply_list = [];
      messages[sendMsgIndex].read_flag = '1'
      messages[sendMsgIndex].reply_list.push(itemMsg)
      unread_count = unread_count-1
      if(this.props.onMarkReadMessage!==undefined){
        this.props.onMarkReadMessage()
      }
      this.setState({messages:messages,sendMsgIndex:-1,unread_count:unread_count})
    }
  }

  renderRowData(){
    const {messages} = this.state

    if(messages.length===0){
      return (
        <tr><td colSpan={4}>ไม่พบข้อมูล...</td></tr>
      )
    }
    
    return messages.map((item,index)=>(
      <tr key={index}>
        <td>{item.added_date}</td>
        <td>{item.sender_name}</td>
        <td>{item.message.type=='image'?this.renderImg(index,item):this.renderText(index,item.message)}
        {this.renderReplyList(item,index)}
        </td>
        <td className='text-center'>
          <Button
            style={{marginRight:'2px'}}
            bsSize="xsmall"
            bsStyle={item.read_flag==='1'?"success":"default"}
            onClick={this.onReadStatusClick.bind(this,index, item.bf_message_id)}
          >
            <FontAwesome name='check' /> 
          </Button>
          {' '} 
          <Button
            style={{marginRight:'2px'}}
            bsSize="xsmall"
            bsStyle="primary"
            onClick={this.onReplyClick.bind(this,index, item.bf_message_id)}
          >
            <FontAwesome name='reply' /> 
          </Button>
          {' '} 
          <Button
            style={{marginLeft:'2px'}}
            bsSize="xsmall"
            bsStyle="danger"
            onClick={this.onDeleteMsgClick.bind(this,index, item.bf_message_id)}
          >
            <FontAwesome name='trash' />
          </Button></td>
      </tr>
    ))
  }

  renderTable() {
    const headerTitles = [
      'เวลาส่ง',
      'ผู้ส่ง',
      'ข้อความ',
      'ดำเนินการ'
    ]

    // const DELETE_MSG_BUTTON = 'deleteMessageButton'
    

    return (
      <div className="table-responsive">
        <table className='table table-hover'>
          {tableHelper.renderHeader(headerTitles)}
          <tbody>
            {this.renderRowData()}
          </tbody>
        </table>
      </div>
    )
  }

  onPageChange(page) {

  }

  renderPaging() {
    return (
      <Row>
        <Col md={12} >
          <ReactPaginate
            previousLabel={"ก่อนหน้า"}
            nextLabel={"ถัดไป"}
            breakLabel={<a href="">...</a>}
            breakClassName={"break-me"}
            pageCount={this.state.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={2}
            onPageChange={this.onPageChange.bind(this)}
            containerClassName={"pagination pull-right"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"} />
        </Col>
      </Row>
    )
  }

  renderMobileTable(){
    let {messages} = this.state
    let fieldMap = {title:'sender_name',amount:'added_date',sub_title:'work_no',date:'',status:'msg',sub_status:''}
    let _data = []
    _data = messages.map((item,index)=>{
      let _item = item
      let work_no = item.message.work_no
      let msg = item.message.text
      _item = Object.assign({work_no:work_no,msg:msg}, _item)
      return _item
    })
    return(
      <div>
        <ReportMobileTable
          itemlist={_data}
          fieldMap={fieldMap}
          keyIndex={'bf_message_id'}
          numberFormat={false}
          ellipsis={false}
        />
      </div>
    )
  }

  render() {
    // const numMessages = this.state.messages.length
    const {show,isMobile} = this.props
    const {showSend,sendMsg,sendMode,unread_count,showConfirmDel} = this.state
    return (
      <div>
        <Modal
          show={show}
          onHide={this.props.onHide}        
          dialogClassName="smallwidth-dialog"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {unread_count > 0 ? unread_count + ' ข้อความใหม่' : 'ไม่มีข้อความใหม่'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Box loading={this.state.loading}>
              <Box.Body>
                {isMobile?this.renderMobileTable():this.renderTable()}
                {/* {this.renderPaging()} */}
              </Box.Body>
            </Box>
            {this.renderPaging()}
          </Modal.Body>
          <Modal.Footer>          
            <Button style={{display:'none'}} onClick={this.onSendClick.bind(this)}><FontAwesome name='send' />&nbsp;ส่งข้อความ</Button>
            <Button style={{display:(unread_count>0)?'':'none'}} bsStyle='danger' onClick={()=>{this.setState({showConfirmDel:true})}}><FontAwesome name='trash' />&nbsp;ลบที่อ่านแล้ว</Button>
            <Button onClick={this.props.onHide}><FontAwesome name='close' />&nbsp;ปิดหน้าต่าง</Button>
          </Modal.Footer>
          <MessageSendModal show={showSend} onHide={()=>{this.setState({showSend:false})}}
          onReplySent={this.onReplySent.bind(this)}
          message={sendMsg}
          mode={sendMode}
          />
        </Modal>
        <ConfirmPopup show={showConfirmDel}
                          title="ยืนยันลบข้อความ"
                          confirmTitle="ตกลง"
                          cancelTitle="ยกเลิก"
                          message={'ยืนยันลบข้อความที่อ่านแล้วทั้งหมด'}
                          onConfirm={this.onArchiveAllReadMessage.bind(this)}
                          onHide={()=>{this.setState({showConfirmDel:false})}}
            />
        <Lightbox
          currentImage={this.state.currentImage}
          images={this.state.images}
          isOpen={this.state.lightboxIsOpen}
          rotatable={true}
          zoomable={true}
          onClickImage={this.onClickImage.bind(this)}
          onClickNext={this.onClickNext.bind(this)}
          onClickPrev={this.onClickPrevious.bind(this)}
          onClose={this.onCloseLightbox.bind(this)}
        />
        <IframeModal 
          ref='iframe' 
          title='ดาวน์โหลดไฟล์' 
        />
        <PurchaseOrderDocModal ref='poDocModal' />
      </div>  
    )
  }
}

MessagePopup.defaultProps = {
  show: false,
  onUpdateUnreadCount:()=>{}
}
const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
})

export default MessagePopup = withSizes(mapSizesToProps)(MessagePopup);


// WEBPACK FOOTER //
// ./src/view/menu/MessagePopup.js